import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Enviar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_9 = { class: "ant-input-group-addon" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_11 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_12 = { class: "ant-input-group-addon" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_19 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_20 = { class: "ant-input-group-addon" }
const _hoisted_21 = ["onUpdate:modelValue"]
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_campo_cpf_cnpj = _resolveComponent("campo-cpf-cnpj")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      width: 800,
      title: _ctx.props.tituloModal,
      "wrap-class-name": "ss-modal-cadastros",
      centered: ""
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.enviarEmail && _ctx.enviarEmail(...args)))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_skeleton, {
              loading: _ctx.state.buscandoEmails,
              paragraph: { rows: 5 }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Pessoa")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_form_item, {
                      label: "CPF/CNPJ",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_campo_cpf_cnpj, {
                          valor: _ctx.state.pessoaEmails.cpfCnpj,
                          "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pessoaEmails.cpfCnpj) = $event)),
                          key: 'cpfCnpj' + _ctx.state.pessoaEmails.cpfCnpj,
                          disabled: true
                        }, null, 8, ["valor"]))
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_a_form_item, {
                      label: "Nome/Razão Social",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.pessoaEmails.nomeRazaoSocial) = $event)),
                          disabled: true
                        }, null, 512), [
                          [_vModelText, _ctx.state.pessoaEmails.nomeRazaoSocial]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, {
                      label: "E-mail Principal",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, [
                            _createVNode(_component_icone, {
                              class: "ss-icone",
                              nome: "email"
                            })
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "ant-input",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pessoaEmails.email) = $event)),
                            disabled: true
                          }, null, 512), [
                            [_vModelText, _ctx.state.pessoaEmails.email]
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.UtilitarioGeral.validaLista(_ctx.state.pessoaEmails.contatoEmails))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_divider, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Contatos")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.pessoaEmails.contatoEmails, (contato, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'ContatoEmail' + index,
                          class: "ant-row"
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_a_form_item, {
                              label: "E-mail",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_11, [
                                  _createElementVNode("span", _hoisted_12, [
                                    _createVNode(_component_icone, {
                                      class: "ss-icone",
                                      nome: "email"
                                    })
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((contato.email) = $event),
                                    disabled: true
                                  }, null, 8, _hoisted_13), [
                                    [_vModelText, contato.email]
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_a_form_item, {
                              label: "Contato",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  "onUpdate:modelValue": ($event: any) => ((contato.nome) = $event),
                                  disabled: true
                                }, null, 8, _hoisted_15), [
                                  [_vModelText, contato.nome]
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-label-show-mobile"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                                  title: "Remover E-mail",
                                  onClick: ($event: any) => (_ctx.removerEmailContatoPessoa(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_17)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.UtilitarioGeral.validaLista(_ctx.state.emailsAdicionais))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_a_divider, null, {
                        default: _withCtx(() => [
                          _createTextVNode("E-mails adicionais para este envio")
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.emailsAdicionais, (email, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'ContatoEmail' + index,
                          class: "ant-row"
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_a_form_item, {
                              label: "E-mail",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, [
                                    _createVNode(_component_icone, {
                                      class: "ss-icone",
                                      nome: "email"
                                    })
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "ant-input",
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.state.emailsAdicionais[index]) = $event),
                                    placeholder: "Digite o e-mail que deseja enviar aqui"
                                  }, null, 8, _hoisted_21), [
                                    [_vModelText, _ctx.state.emailsAdicionais[index]]
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-label-show-mobile"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-secondary ss-tamanho-completo",
                                  title: "Remover E-mail",
                                  onClick: ($event: any) => (_ctx.removerEmailAdicional(index))
                                }, [
                                  _createVNode(_component_icone, { nome: "excluir" })
                                ], 8, _hoisted_23)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]))
                      }), 128))
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria ss-tamanho-completo",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.adicionarEmail()))
                    }, "Adicionar E-mail")
                  ])
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}